import {Button, styled} from "@mui/material";
import {HoverElevationButton} from "./base-buttons";

export const NewOrderAddButton = styled(HoverElevationButton)(({theme}) => ({
    width: '280px',
    height: '57px',

    backgroundColor: theme.barekam.orderPopup.buttons.add.backgroundColor,
    color: theme.barekam.orderPopup.buttons.add.color,

    '&:hover': {
        backgroundColor: theme.barekam.orderPopup.buttons.add.backgroundHoverColor,
    },

    '& img': {
        width: '12px',
        height: '12px',
        marginRight: '0.75rem',
        filter: 'brightness(0%)'
    }
}));

export const NewOrderAddButtonSmall = styled(NewOrderAddButton)(() => ({
    width: '5.25rem',
    height: '2.25rem',
    borderRadius: '2.25rem',

    color: "#FFF",
}));

// Summary pay button
export const OrderSummaryButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.barekam.orderList.summary.paymentButton.backgroundColor,
    color: '#FFF',

    height: '2.63rem',
    width: '100%',
    display: 'flex',
    padding: '0.75rem 1.5rem',
    alignItems: 'center',

    borderRadius: 0,

    '&:hover': {
        backgroundColor: theme.barekam.orderList.summary.paymentButton.backgroundColor,
    }
}));

export const OrderSummaryButtonDisabled = styled(OrderSummaryButton)(({theme}) => ({
    backgroundColor: theme.barekam.orderList.summary.paymentButton.backgroundColorDisabled,
}));


// Order popup buttons
export const OrderPopupPayButton = styled(HoverElevationButton)(({theme}) => ({
    backgroundColor: theme.barekam.green,
    color: '#fff',

    display: 'flex',
    height: '3rem',
    padding: '0.75rem 1.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.75rem',
    borderRadius: '0.5rem',

    '&:hover': {
        backgroundColor: theme.barekam.green,
    }
}));

export const OrderPopupPayButtonDisabled = styled(OrderPopupPayButton)(({theme}) => ({
    backgroundColor: theme.barekam.mediumGrey,

    '&:hover': {
        backgroundColor: theme.barekam.mediumGrey,
    },
    color: '#FFF'
}));

// Order export button
export const OrderExportButton = styled(HoverElevationButton)(() => ({
    height: '2.5rem',
    width: 'max-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
}));

export const OrderAddProductButton = styled(Button)(({theme}) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 'unset',
    width: 'max-content',
    color: theme.barekam.green,
    padding: '0.5rem 1rem',
    gap: '0.5rem',

    '& img': {
        filter: 'invert(16%) sepia(100%) saturate(4426%) hue-rotate(152deg) brightness(94%) contrast(94%)'
    }
}));

export const OrderWarehouseCardButton = styled(Button)(() => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 'unset',
    width: '2.6rem',
    height: '100%',
    backgroundColor: '#f1f1fb80',
}));